import { render, staticRenderFns } from "./homepagedescription.vue?vue&type=template&id=4295ff4a&scoped=true&"
import script from "./homepagedescription.vue?vue&type=script&lang=js&"
export * from "./homepagedescription.vue?vue&type=script&lang=js&"
import style0 from "./homepagedescription.vue?vue&type=style&index=0&id=4295ff4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4295ff4a",
  null
  
)

export default component.exports